// extracted by css-extract-rspack-plugin
export default {"sizeFluid":"100%","spaceSmall":"12px","ctaWidgetContainer":"cta-widget__ctaWidgetContainer___xZh2l","ctaWidgetButtonsContainer":"cta-widget__ctaWidgetButtonsContainer___phMiZ"};